import { enrollFormFieldKeys } from '../../consts';

export const reversedFieldKeys: Record<string, string> = Object.fromEntries(
  Object.entries(enrollFormFieldKeys).map(([formKey, apiKey]: [string, string]): [string, string] => [apiKey, formKey])
);
